import { createVNode as d, mergeProps as e } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/LoadingFilledStandard.js";
import n from "../components/PfIcon.js";
const r = (t, a) => {
  const o = {
    ...t,
    ...a.attrs
  };
  return d(n, e(o, {
    icon: i
  }), null);
};
r.displayName = "LoadingFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
